import React, { memo } from 'react';
import {stateFromMarkdown} from 'draft-js-import-markdown';
import {stateToHTML} from 'draft-js-export-html';

export const isNotNull = v => v && v !== '' && v !== "​\n";

export default memo(({children}) => <div dangerouslySetInnerHTML={{__html:isNotNull(children) ? stateToHTML(stateFromMarkdown(children)) : '' }} />)
